import styled from 'styled-components';
import { DIMENSIONS } from '@hqo/react-components-library/dist/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const HeaderTitle = styled.div`
  color: ${({ theme }) => theme.colors.palette.systemBlack};
  font: 500 28px/32px ${({ theme }) => theme.fonts.join()};
`;

export const StyledBackLink = styled.div`
  padding-left: 52px;
`;

export const Container = styled.div<{ $withTopPadding?: boolean; $withBelowTitle?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* No bottom padding under a filled slot: the slot's own rule is meant to be the frame's edge. */
  padding: ${({ $withTopPadding = true }) => ($withTopPadding ? '55px' : '0')} 52px
    ${({ $withBelowTitle }) => ($withBelowTitle ? '0' : '35px')} 52px;
  width: 100%;
  /*
   * RES-1367: the header is the part of a page that does NOT move. Pages that pin themselves to the
   * frame stack it above their scroll port, so flex: 0 0 auto is what stops the row being squeezed
   * as the scrolling sibling grows -- a flex item shrinks by default.
   *
   * box-sizing because this app has no global one (app.css skips Preflight deliberately): width:
   * 100% plus 52px gutters was 104px wider than its parent, which is a horizontal scrollbar on
   * every page carrying this header.
   */
  flex: 0 0 auto;
  box-sizing: border-box;
  gap: 15px;
  align-items: flex-start;
  /* One rule under the chunk: the slot draws its own hairline, so the frame yields its 2px border. */
  border-bottom: ${({ $withBelowTitle, theme }) =>
    $withBelowTitle ? 'none' : `2px solid ${theme.colors.greys.adminGreyMedium}`};

  /*
   * 52px is a desktop gutter. This header used to be hidden below this width -- a native app header
   * stood in for it -- so it never met a narrow one; now that the portal renders it at every width,
   * it takes the same 16px the page body already takes down here.
   */
  @media only screen and (max-width: ${DIMENSIONS.MEDIUM}) {
    padding: ${({ $withTopPadding = true }) => ($withTopPadding ? '24px' : '0')} 16px
      ${({ $withBelowTitle }) => ($withBelowTitle ? '0' : '20px')} 16px;
  }
`;

/*
 * `width: 100%` is load-bearing: `Container` is `align-items: flex-start`, so without it this row
 * shrink-wraps and a tab strip's rule stops at the end of its last word.
 */
export const BelowTitle = styled.div`
  width: 100%;
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

export const StyledCalendarIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.palette.systemBlack};
  width: 21px;
  height: 25px;
`;

export const RightPane = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
`;

export const LeftPane = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Text = styled.div`
  color: ${({ theme }) => theme.colors.palette.systemBlack};
  font: 500 16px / normal ${({ theme }) => theme.fonts.join()};
`;
